export const messages = {
  en: {
    shopHouse1: {
      title: 'Warehouse Management',
      id: 'Warehouse ID',
      name: 'Warehouse Name',
      type: 'Warehouse Type',
      typeOptions: {
        normal: 'Normal Warehouse',
        main: 'Main Warehouse'
      },
      desc: 'Description',
      createTime: 'Create Time',
      operations: 'Operations',
      addTitle: 'Add Warehouse',
      editTitle: 'Edit Warehouse',
      form: {
        name: 'Warehouse Name',
        type: 'Warehouse Type',
        desc: 'Description',
        rules: {
          nameRequired: 'Please input warehouse name',
          typeRequired: 'Please select warehouse type'
        }
      }
    }
  },
  zh: {
    shopHouse1: {
      title: '仓库管理',
      id: '仓库编号',
      name: '仓库名称',
      type: '仓库类型',
      typeOptions: {
        normal: '普通仓库',
        main: '总仓库'
      },
      desc: '描述',
      createTime: '创建时间',
      operations: '操作',
      addTitle: '添加仓库',
      editTitle: '编辑仓库',
      form: {
        name: '仓库名称',
        type: '仓库类型',
        desc: '描述',
        rules: {
          nameRequired: '请输入仓库名称',
          typeRequired: '请选择仓库类型'
        }
      }
    }
  }
}